import "./index.scss";

import { Grid, Stack } from "@mui/material";
import React, { FC } from "react";

interface FormWrapperProps {
  label?: string;
  isRequired?: boolean;
  alignItems?: string;
  children?: React.ReactNode;
}

const FormWrapper: FC<FormWrapperProps> = (props) => {
  const { label, children, isRequired, alignItems = "baseline" } = props;

  return (
    <Grid container alignItems={alignItems} mb="20px" pr="10px">
      {label ? (
        <>
          <Grid item xs={12} sm={4} pr="20px">
            <h3 className="h3 regular-secondary formWrapperLabel">
              {label}
              {isRequired && <>&nbsp;*</>}
            </h3>
          </Grid>
          <Grid item xs={12} sm={8}>
            {children}
          </Grid>
        </>
      ) : (
        <Grid item>{children}</Grid>
      )}
    </Grid>
  );
};

export default FormWrapper;
